import {FC, ReactNode} from 'react'
import {useInitSocketAuth} from '@/features/notifications/hooks/useInitSocketAuth'
import {useSocketNotifications} from '@/features/notifications/hooks/useSocketNotifications'

interface NotificationsProviderProps {
    userId: string
    children: ReactNode
}

export const NotificationsProvider: FC<NotificationsProviderProps> = ({userId, children}) => {
    // Initialize socket authentication
    useInitSocketAuth()
    useSocketNotifications(userId)

    return <>{children}</>
}
